import { AnalyticsStandardEvent } from '../types/index';

export const formStart: AnalyticsStandardEvent = {
  event: 'form_start',
};

export const formComplete: AnalyticsStandardEvent = {
  event: 'form_complete',
};
